import { lazy, Suspense } from 'react'
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router'
import { AudioProvider } from './audio/AudioProvider'
import { Layout } from './components/Layout'
import { Loading } from './components/States'
import { Archive } from './pages/Archive'
import { Home } from './pages/Home'
import { NotFound } from './pages/NotFound'
import { Story } from './pages/Story'
import { TheoryPage } from './pages/TheoryPage'

// The admin is a separate chunk — visitors reading theories never download it.
const AdminApp = lazy(() => import('./admin/AdminApp'))

/**
 * Audio sits above the router outlet so a recording keeps playing across every
 * navigation, including into the admin.
 */
function Root() {
  return (
    <AudioProvider>
      <Outlet />
    </AudioProvider>
  )
}

// A data router (rather than <BrowserRouter>) is required for useBlocker, which
// the editor uses to catch navigation away from unsaved changes.
const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        element: <Layout />,
        children: [
          { index: true, element: <Home /> },
          { path: 'story', element: <Story /> },
          { path: 'theories', element: <Archive /> },
          { path: 'theory/:slug', element: <TheoryPage /> },
          { path: '*', element: <NotFound /> },
        ],
      },
      {
        path: 'admin/*',
        element: (
          <Suspense fallback={<Loading label="Loading admin…" />}>
            <AdminApp />
          </Suspense>
        ),
      },
    ],
  },
])

export function App() {
  return <RouterProvider router={router} />
}
